import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const Clear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)
